import React from "react";
import './WhyUs.css'
export default function WhyUs() {
    const icons = [
        {
            id: 1,
            Heading: "Customised Printing Solutions",
            description: "We offer tailor-made printing services to meet the unique needs of every business. Our solutions align perfectly with your goals, from branding materials to promotional items.",
            image: "/customprints.png", // Placeholder image URL
        },
        {
            id: 2,
            Heading: "Quality Materials & Precision",
            description: "Our printing services ensure vibrant visuals and durable materials that leave a lasting impression. Advanced technology guarantees precision and premium results every time.",
            image: "/hignquality.png", // Placeholder image URL
        },
        {
            id: 3,
            Heading: "Efficient Bulk Printing Services",
            description: "With our bulk printing solutions, you can enjoy competitive pricing and consistent quality. We handle large-scale projects with ease delivering results promptly and efficiently.",
            image: "/bulkprints.png", // Placeholder image URL
        },
        {
            id: 4,
            Heading: "Quick Turnaround Times",
            description: "Time-sensitive projects? We guarantee fast and reliable delivery without compromising quality. Trust us to meet your deadlines with efficiency.",
            image: "/timelydelivery.png", // Placeholder image URL
        },
        {
            id: 5,
            Heading: "Comprehensive Industry Expertise",
            description: "We serve diverse sectors, including retail, hospitality, education, and healthcare. Our industry-specific printing solutions ensure maximum impact for your brand.",
            image: "/indusexpertise.png", // Placeholder image URL
        },
        {
            id: 6,
            Heading: "Sustainable and Eco-Friendly Options",
            description: "We are committed to sustainability and offer eco-friendly printing materials and processes. Choose us for high-quality printing that’s environmentally responsible.",
            image: "/ecofriendly.png", // Placeholder image URL
        },
    ];

    return (
        <div className="container">
            <div className=" whyus-outer">
          <div className="whyus-inner">
          <div className="container whyus-topheading">
          <h2 className="text-center ">Our USPs - Why Choose Us for Your Printing Needs</h2>
         
          </div>
            <div className="row whyus-row">
                {icons.map((icon) => (
                    <div key={icon.id} className="col-md-4 dropdown-container">
                        <div className="whyus-item">
                           
                            <div className=" whyus-border">
           <div className="color-transition-div">
           <img src={icon.image} alt={icon.Heading} className="whyus-image " />
           </div>
</div>
                            
                            <h5 className="whyus-heading">{icon.Heading}</h5>
                            <p className="whyus-para">{icon.description}</p>
                

                        </div>
                    </div>
                ))}
            </div>
          </div>
          
        </div>
        </div>
    );
}
